import {Component, Inject, OnDestroy} from "@angular/core";
import {Editor, Toolbar} from "ngx-editor";
import {AlertsService} from "@app/utilities/alerts.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {NewsService} from "@app/services/news/news.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'edit-article',
    templateUrl: './edit-article.component.html',
    styleUrls: ['./edit-article.component.css']
})
export class EditArticleComponent implements OnDestroy{
    description: Editor;
    html: '';
    details: Editor;
    //used to edit buttons on the toolbar in text editor
    toolbar: Toolbar = [['bold','italic','underline','ordered_list','bullet_list', 'link']]
    newsForm :FormGroup;
    constructor(public newsService: NewsService, public snackBar: AlertsService, @Inject(MAT_DIALOG_DATA) public passedData) {
        //used to set the article information if it is not a new article
        this.description = new Editor();
        this.details = new Editor();
        this.newsForm = new FormGroup({
            title: new FormControl(this.passedData.data.isNew ? null: this.passedData.data.article.title, [Validators.required]),
            description: new FormControl(this.passedData.data.isNew ? null: this.passedData.data.article.description, [Validators.required]),
            id: new FormControl(this.passedData.data.isNew ? null: this.passedData.data.article.id, [Validators.required]),
            catergories: new FormControl(this.passedData.data.isNew ? null: this.passedData.data.article.catergories, ),
            orderNum: new FormControl(this.passedData.data.isNew ? null: this.passedData.data.article.orderNum, ),
            details: new FormControl(this.passedData.data.isNew ? '': this.passedData.data.article.details ?? '', [Validators.required]),
        })
    }

    //unsubscribes from details and description when dialog is closed
    ngOnDestroy(): void {
        this.description.destroy();
        this.details.destroy();
    }

    //calls add if its a new article or call edit if not
    onSubmit() {
        this.passedData.data.isNew ? this.newsService.add(this.newsForm.value):  this.newsService.edit(this.newsForm.value);
    }
}

